import { MapPinIcon } from '@heroicons/react/24/solid'
import { ReactElement, useMemo } from 'react'
import ComboMultiSelect from 'app/components/ui/combo/combo-multi-select'
import { useLocationIntegrationStatus } from 'app/hooks/useLocationIntegrationStatus'
import { OptionType } from 'types/OptionType'

/**
 * Component that searches for locations and returns a locations dropdown with integration status icon.
 * @returns Component with locations to be used as filter
 */
export function LocationSelector({
  inputClassName,
  selectedLocations,
  onLocationsChange,
}: {
  inputClassName?: string
  selectedLocations: string[]
  onLocationsChange: (locations: string[]) => void
}): ReactElement {
  const allLocationsOption = { name: `All Locations`, id: `0`, value: `` }
  const { locationOptions } = useLocationIntegrationStatus([selectedLocations])

  const selectedOptions = useMemo(() => {
    const selectedLocationOptions = locationOptions.filter((option) => selectedLocations.includes(option.value))
    return selectedLocationOptions
  }, [locationOptions, selectedLocations])

  return (
    <ComboMultiSelect
      className="w-52 cursor-pointer"
      optionsContainerClassName="w-64 right-0"
      placeholder="filter by locations"
      values={selectedOptions}
      options={locationOptions}
      name="location-selector"
      onChange={(options) => onLocationsChange(options.map((option) => option.value))}
      icon={<MapPinIcon className="h-4 w-4 fill-current text-default" />}
      enableDeselectAllOption={true}
      deselectAllOptions={[allLocationsOption]}
      inputClassName={inputClassName}
      isFilter
    />
  )
}
